import { useState, useCallback } from 'react';
import { usePastVisits } from '../../api/queries';
import { useVisitModals } from '../../hooks/useVisitModals';
import { VisitListPage } from '../../components/visits/VisitListPage';
import { VisitDetailModal } from '../../components/visits/VisitDetailModal';
import { filterByDate } from '../../utils/visits';
import type { Visit } from '../../types';

export function PastVisitsPage() {
  const { data: pastVisits = [], isLoading } = usePastVisits();
  const { modals } = useVisitModals();
  const [detailModal, setDetailModal] = useState<{ open: boolean; visit: Visit | null }>({ open: false, visit: null });
  const [dateRange, setDateRange] = useState('all');

  const dateFilterFn = useCallback((visits: Visit[]) => filterByDate(visits, dateRange), [dateRange]);

  return (
    <>
      <VisitListPage
        visits={pastVisits}
        isLoading={isLoading}
        emptyMessage="Past visits will appear here after you complete your first visit."
        showStatus
        onVisitClick={(v) => setDetailModal({ open: true, visit: v })}
        filterFn={dateFilterFn}
        heading={<h2><svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: '-2px', marginRight: '0.35rem' }}><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><rect x="8" y="2" width="8" height="4" rx="1" /></svg>Past Visits</h2>}
        dateFilter={
          <select value={dateRange} onChange={(e) => setDateRange(e.target.value)} style={{ padding: '0.35rem 0.6rem', fontSize: '0.85rem', border: '1px solid var(--border-color)', borderRadius: 'var(--radius)', outline: 'none' }}>
            <option value="all">All Time</option>
            <option value="today">Today</option>
            <option value="week">This Week</option>
            <option value="month">This Month</option>
          </select>
        }
      />

      <VisitDetailModal visit={detailModal.visit} open={detailModal.open} onClose={() => setDetailModal({ open: false, visit: null })} isPastVisit />
      {modals}
    </>
  );
}
